import React, { Fragment, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import clsx from 'clsx';
import Icon from '@components/atoms/icon/icon';
import useGuidedSearchQuery from '@hooks/catalog-context/use-guided-search-query';
import { useAnalytics } from '@context/analytics/analytics.context';
import CmsImages from '@components/atoms/vc-images/components/cms-image';
import styles from './catalog-header-navigation.module.scss';

const CatalogHeaderNavigation: React.FC = (): React.JSX.Element => {
  const { guidedSearch } = useGuidedSearchQuery();

  const dataPage = {
    isMainPage: guidedSearch?.is_main_page,
    carousel: guidedSearch?.items,
  };

  const { t } = useTranslation();
  const { scriptsEventData } = useAnalytics();
  const { sendAnalyticEvent: sendTopNavEvent } = useAnalyticEvents('top_navigation');

  const isMainPage = dataPage?.isMainPage;
  const getBlockNameForTracking = (text: string) => {
    return (
      text
        .toLowerCase()
        .split(' ')
        .filter((word) => word.length > 1)
        .join('_') || ''
    );
  };

  useEffect(() => {
    if (scriptsEventData?.isTcEvents1Loaded && scriptsEventData?.isTcEvents7Loaded) {
      sendTopNavEvent('top_navigation_view');
    }
  }, [scriptsEventData?.isTcEvents1Loaded, scriptsEventData?.isTcEvents7Loaded]);

  return (
    <Fragment>
      {dataPage?.carousel?.length > 0 && (
        <span className={styles.headerNavigation__title}>{t('CATALOG.TOPNAV.TITLE')}</span>
      )}
      <div className={styles.headerNavigationContainer}>
        <ul
          className={clsx(styles.headerNavigation, {
            [styles['headerNavigation--brandCategory']]: !isMainPage,
          })}
          data-cy="guided_search_main"
        >
          {dataPage?.carousel?.map((item, index) => {
            const blockName = item?.title;
            const blockImageSrc = item?.image?.url;
            return (
              <li
                key={`${item?.title}_${index}`}
                className={styles.headerNavigation__item}
              >
                <a
                  href={item?.url}
                  onClick={() =>
                    sendTopNavEvent('top_navigation_click', { property: getBlockNameForTracking(blockName) })
                  }
                  className={styles.headerNavigation__item__link}
                  data-cy="guided_search_part"
                >
                  {isMainPage && blockImageSrc && (
                    <CmsImages
                      className={styles.headerNavigation__item__brandImg}
                      src={blockImageSrc}
                      // width and height of images that should be received - values may change upon results of testing
                      height={304}
                      width={710}
                      alt=""
                      type="edito"
                      priority
                      disableLazyLoad
                    />
                  )}
                  <div className={styles.headerNavigation__item__title}>
                    {!isMainPage && (
                      <div className={styles.headerNavigation__item__smallImg}>
                        <CmsImages
                          src={blockImageSrc}
                          height={48}
                          width={48}
                          alt=""
                          type="edito"
                          priority
                          disableLazyLoad
                        />
                      </div>
                    )}
                    <span className={styles.headerNavigation__item__title__text}>{blockName}</span>
                    {isMainPage && (
                      <Icon
                        name="arrow-right-long-20"
                        className={styles.arrowIcon}
                        ariaHidden
                      />
                    )}
                  </div>
                </a>
                <span className={styles.headerNavigation__item__fakePadding}></span>
              </li>
            );
          })}
        </ul>
      </div>
    </Fragment>
  );
};

export default CatalogHeaderNavigation;
